// Central content + real NK Bridal (Nancy's) gown photography
const A = {
  beadedColumn: "https://customer-assets-rejwkqb3.emergentagent.net/job_c2ace06b-eb95-4eb9-871b-f8783f8db404/artifacts/fzrzp4ky_normal_2024D_A7406913.webp",
  miniFront: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/mljnvjwm_normal_2024D_A7406989.webp",
  miniBack: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/1mh8l9b8_normal_2024D_A7406977.webp",
  sofa: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/fvima9a4_normal_2024D_A7406957.webp",
  aLineFront: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/pbpjrsfg_normal_2024D_A7406947.webp",
  cathedralBack: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/dmv1urri_normal_2024D_A7406941.webp",
  sequinSheath: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/dgxhdn1t_normal_2024D_A7406845.webp",
  satinSlit: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/dkm0wa8w_normal_2024D_A7406893.webp",
  mikadoSide: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/a9jbj2y5_normal_2024D_A7406875.webp",
  pearlMermaid: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/aisqsun7_normal_2024D_A7406904.webp",
  pearlFront: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/xc0303c3_normal_2024D_A7406824.webp",
  capedGown: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/ovarbx04_normal_2024D_A7406796.webp",
  twoBrides: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/ug22mqef_normal_2024D_A7406776.webp",
  sofaBlonde: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/cfrjhf2p_normal_2024D_A7406753.webp",
  couple: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/97njgpb8_normal_2024D_A7406605.webp",
  backlessSatin: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/mqwubg1j_normal_2024D_A7406556.webp",
};

export const IMAGES = {
  heroPrimary: A.beadedColumn,
  manifesto: A.mikadoSide,
  testimonial: A.pearlFront,
  statement: A.twoBrides,
};

export const NANCY_VIDEO = "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/kqjus7hl_hf_20260817_033525_317d7690-c260-47c6-93db-40554900fe04.mp4";

export const NANCY_VIDEO_HERO = "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/os3xv9q5_hf_20260817_040534_fd54952d-d41f-436a-9645-148f5ba0efc1.mp4";

const N = {
  consultLounge: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/l2k0lcbv_hf_20260831_085512_da773170-8100-4b28-a874-853c760921da.png",
  sketching: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/lfk6l8hc_hf_20260817_034801_25a5863b-385c-4f39-a4e3-6ae7867c50f0.png",
  laptop: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/8eh8uc7u_hf_20260817_030847_4275b1d3-36b1-40bb-9ede-b0df89a3c365.png",
  sew: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/tp6ms8xh_hf_20260817_030948_4a1dc82f-1881-4c7d-9ba9-b2e496806b73.png",
  measureFull: "https://customer-assets-jai6qajn.emergentagent.net/job_bridal-australia-hub/artifacts/ol8z477u_hf_20260817_032014_2c6e8265-940e-498e-badf-36180ab032a5.png",
};

export const PROCESS = [
  {
    no: "01",
    title: "Enquiry & Consultation",
    body: "It begins with a conversation. Meet Nancy in her Perth studio or online to talk through your day, your vision and your budget over fabric swatches and first ideas. Interstate brides are welcome — online quoting makes starting from anywhere easy.",
    img: N.consultLounge,
    pos: "object-center",
  },
  {
    no: "02",
    title: "Design & Sketch",
    body: "Nancy sketches your gown from scratch, shaping silhouette, fabric and detail around you. Every idea is considered — nothing is pulled from a rack. Together you refine the design until it feels unmistakably yours.",
    img: N.sketching,
    pos: "object-center",
  },
  {
    no: "03",
    title: "Design Approval",
    body: "Your final design, fabrics and measurements are drawn together and confirmed. Nancy walks you through every detail — in the studio or over a screen share — so you sign off knowing exactly what will be made.",
    img: N.laptop,
    pos: "object-top",
  },
  {
    no: "04",
    title: "Manufacturing",
    body: "In the atelier your gown takes shape. Nancy cuts each panel and sews it herself, building the structure, layering lace and setting every bead by hand — the craftsmanship you'll never see, but always feel.",
    img: N.sew,
    pos: "object-center",
  },
  {
    no: "05",
    title: "Measurements & Fittings",
    body: "Your gown is brought to life across a series of fittings. Nancy measures and adjusts by hand, travelling to you where needed, refining the fit until it feels effortless and entirely natural.",
    img: N.measureFull,
    pos: "object-center",
  },
  {
    no: "06",
    title: "Hand-Finished & Yours",
    body: "Final seams, closures and finishing touches are completed by Nancy herself — then it's yours to wear down the aisle. A one-of-a-kind gown, made to move with you and to hold the day exactly as you dreamed it.",
    img: A.couple,
    pos: "object-top",
  },
];

export const BIO = [
  "Nancy Khau is the designer, dressmaker and heart behind NK Bridal Australia. Since 2013 she has been creating custom-made wedding gowns and formal wear — first through her own label, Nancy Khau Boutique, and then under NK Bridal, where she built a reputation as one of Brisbane's most sought-after bridal designers.",
  "Every NK Bridal gown is designed, cut and sewn by Nancy herself. She works with brides one-on-one from the very first sketch, taking the time to understand your body, your style and the way you want to feel on the day. Rather than fitting you into a dress off the rack, Nancy builds the dress around you, so the finished gown is truly one of a kind.",
  "In 2018 Nancy took time away from the studio to travel and train overseas, refining her technique and returning with a fresh, modern approach to bridal design. That blend of classic couture craftsmanship and contemporary style is what NK Bridal is known for today: clean lines, thoughtful details and a fit that feels effortless.",
  "Nancy is now based in Perth, Western Australia, and works with brides across the country. Whether you're local or interstate, she can travel to you for consultations and fittings, and offers online quoting and design consultations for brides who prefer to begin the process remotely.",
];

export const BIO_PULLQUOTE = "No brief is too small, no idea too ambitious. If you can imagine it, Nancy would love to help you wear it.";

export const ALTERATIONS = [
  { t: "Hem & Length", d: "Shortening and levelling hems with horsehair, lace-edge and rolled finishes." },
  { t: "Take In & Let Out", d: "Bodice, waist and side seams adjusted for a flawless, sculpted fit." },
  { t: "Bustles", d: "Custom over- and under-bustles to lift your train for the reception." },
  { t: "Cups & Support", d: "Sewn-in cups, bra inserts and modesty panels for comfort and support." },
  { t: "Straps & Sleeves", d: "Adding, removing or restyling straps, sleeves and off-shoulder details." },
  { t: "Back & Closures", d: "Zips, buttons and corset-back conversions repaired or restyled." },
  { t: "Beading & Lace", d: "Invisible repair and restoration of beading, lace and appliqué." },
  { t: "Restyle & Redesign", d: "Reworking existing or heirloom gowns into something entirely new." },
];

export const ALTERATION_STEPS = [
  { no: "01", t: "Book a Fitting", d: "Bring your gown to the Perth studio, or arrange a travelling fitting." },
  { no: "02", t: "Pin & Quote", d: "Nancy pins the gown to your body and quotes the work upfront." },
  { no: "03", t: "Alterations", d: "Every adjustment is completed by hand in the atelier." },
  { no: "04", t: "Final Fit & Press", d: "A final fitting and steam, so it's ready to wear down the aisle." },
];

export const COLLECTIONS = [
  { name: "Lumière", line: "Sequin Sheath", img: A.sequinSheath, span: "md:col-span-7", ratio: "aspect-[4/5]", pos: "object-top" },
  { name: "Océane", line: "Beaded Cape", img: A.capedGown, span: "md:col-span-5", ratio: "aspect-[4/5]", pos: "object-top" },
  { name: "Aveline", line: "Off-Shoulder Lace", img: A.sofa, span: "md:col-span-12", ratio: "aspect-[21/9]", pos: "object-center" },
  { name: "Wildflower", line: "3D Floral Mini", img: A.miniFront, span: "md:col-span-4", ratio: "aspect-[3/4]", pos: "object-top" },
  { name: "Fleur", line: "Open-Back Mini", img: A.miniBack, span: "md:col-span-4", ratio: "aspect-[3/4]", pos: "object-top" },
  { name: "Bianca", line: "Floral A-Line", img: A.aLineFront, span: "md:col-span-4", ratio: "aspect-[3/4]", pos: "object-top" },
  { name: "Cascade", line: "Cathedral Train", img: A.cathedralBack, span: "md:col-span-6", ratio: "aspect-[4/5]", pos: "object-center" },
  { name: "Celestine", line: "Satin Off-Shoulder", img: A.satinSlit, span: "md:col-span-6", ratio: "aspect-[4/5]", pos: "object-top" },
  { name: "Genevieve", line: "Floral Ballgown", img: A.sofaBlonde, span: "md:col-span-12", ratio: "aspect-[21/9]", pos: "object-center" },
  { name: "Astral", line: "Pearl Mermaid", img: A.pearlMermaid, span: "md:col-span-6", ratio: "aspect-[4/5]", pos: "object-top" },
  { name: "Seraphine", line: "Hand-Beaded Column", img: A.beadedColumn, span: "md:col-span-6", ratio: "aspect-[4/5]", pos: "object-top" },
  { name: "Élodie", line: "Beaded Mermaid", img: A.couple, span: "md:col-span-6", ratio: "aspect-[4/5]", pos: "object-top" },
  { name: "Simone", line: "Cowl-Back Satin", img: A.backlessSatin, span: "md:col-span-6", ratio: "aspect-[4/5]", pos: "object-top" },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Designed, cut and sewn by hand",
    body: "Since 2013, Nancy Khau has created custom wedding gowns and formal wear — first as Nancy Khau Boutique, then as NK Bridal, one of Brisbane's most sought-after bridal labels. Every gown is designed, cut and sewn by Nancy herself.",
  },
  {
    no: "02",
    title: "Built around you, never off the rack",
    body: "Nancy works with you one-on-one from the very first sketch — understanding your body, your style and the way you want to feel. Rather than fitting you into a dress off the rack, she builds the gown around you, so it is truly one of a kind.",
  },
  {
    no: "03",
    title: "Classic couture, modern lines",
    body: "In 2018 she travelled and trained overseas, returning with a fresh, contemporary approach. That blend of couture craftsmanship and modern style defines NK Bridal today: clean lines, thoughtful details and a fit that feels effortless.",
  },
  {
    no: "04",
    title: "Wherever you are",
    body: "Now based in Perth, Western Australia, Nancy works with brides across the country — travelling for consultations and fittings, with online quoting and design consults for those who prefer to begin remotely. No brief is too small, no idea too ambitious.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "I walked in unsure and walked out in tears. Nancy found a gown I would never have chosen for myself — and it was the one.",
    name: "Alessia R.",
    place: "Married in Perth",
  },
  {
    quote: "She built the dress around me from the first sketch. It never once felt like a transaction — it felt like being dressed by a friend.",
    name: "Priya M.",
    place: "Brisbane wedding",
  },
  {
    quote: "The beadwork on my gown stopped the entire room. Six months on and my guests still talk about the dress.",
    name: "Chloe T.",
    place: "Interstate bride",
  },
];
